import React from 'react';
import './Weather.css';
import FMSimage from '../Assets/weather1.jpg'; // First image (full size)
import FMSimage2 from '../Assets/weather2.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/weather3.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/weather4.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/weather5.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">WEATHER MONITORING</h1>
                    <p className="FMS-description">
                        The Weather Monitoring System (WMS) from Vajra IoT is an advanced solution for real-time monitoring of weather conditions. It optimizes environmental data collection, ensures accurate forecasts, and enhances decision-making, making it an essential tool for various industries.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Weather Monitoring" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Real-Time Data:</strong> Monitor weather parameters such as temperature, humidity, and rainfall in real-time.</li>
                            <li><strong>Early Warning System:</strong> Receive alerts for severe weather conditions like storms or heavy rainfall.</li>
                            <li><strong>Remote Monitoring:</strong> Access weather data remotely through user-friendly platforms.</li>
                            <li><strong>Customizable Solutions:</strong> Tailor the system to specific environmental monitoring needs.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Advanced Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Centralized Monitoring:</strong> A cloud-based system collects and displays weather data in real-time.</li>
                            <li><strong>Automated Alerts:</strong> Detect unusual patterns and send notifications for quick response.</li>
                            <li><strong>Data Analysis:</strong> Provide insights into weather trends for better planning and decision-making.</li>
                            <li><strong>Sensor Accuracy:</strong> High-precision sensors ensure reliable environmental data collection.</li>
                        </ul>
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Weather Monitoring System</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Reliable Data:</strong> Provides consistent and accurate weather information.</li>
                            <li><strong>Customizable Solutions:</strong> Tailored to suit diverse monitoring needs across industries.</li>
                            <li><strong>Cost-Effective:</strong> Minimizes operational costs with efficient monitoring systems.</li>
                            <li><strong>Ease of Use:</strong> A user-friendly interface ensures seamless access to weather data.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our WMS */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using WMS" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Weather Monitoring System is trusted by various sectors for its accuracy and reliability. These industries rely on our system to optimize operations and reduce environmental risks:
                        <ul>
                            <li>Agriculture</li>
                            <li>Construction</li>
                            <li>Transportation</li>
                            <li>Energy</li>
                            <li>Urban Planning</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FMS;
